import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const SendEmailForVerification = async (Email) => {
  try {
    let userDoc = await collection(db, "users");
    const q = query(userDoc, where("email", "==", Email));
    userDoc = await getDocs(q);
    if (userDoc.docs.length === 0) return false;
    const docData = userDoc.docs[0].data();
    const { uid } = docData;
    const data = {
      ...docData,
      verification_email_sent: false,
    };
    await setDoc(doc(db, "users", uid), data);
    return uid;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export default SendEmailForVerification;
